import { PaymentPlanLineStatus } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const PaymentStatusOptions = Object.values(PaymentPlanLineStatus).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
